module.exports = __webpack_public_path__ + "src/components/@atoms/CaFooter/images/1VL2Eww.svg";